import { render, staticRenderFns } from "./MortgageMenu.vue?vue&type=template&id=1af62ec4&scoped=true"
import script from "./MortgageMenu.vue?vue&type=script&lang=js"
export * from "./MortgageMenu.vue?vue&type=script&lang=js"
import style0 from "./MortgageMenu.vue?vue&type=style&index=0&id=1af62ec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af62ec4",
  null
  
)

export default component.exports